import React, { useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';

const debouncedResizeEvent = new Event('debouncedresize');

const VisibleHeight = createGlobalStyle`
   :root {
      --visible-height: ${({ height }) => height}px;
      --visible-and-safe-height: calc(var(--visible-height) - var(--safe-area-inset-y))
   }
`;

const debounce = (func, timeout = 300) => {
   let timer;
   return () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
         func();
      }, timeout);
   };
};

const windowResizeDebounced = (func) => {
   const debouncedFunc = debounce(func);

   window.addEventListener('resize', debouncedFunc);
   return () => {
      window.removeEventListener('resize', debouncedFunc);
   };
};

const VisibleScreenDimentions = () => {
   const [visibleDimensions, setVisibleDimensions] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
   });

   useEffect(() => {
      windowResizeDebounced(() =>
         setVisibleDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
         })
      );
   }, []);

   useEffect(() => {
      window.dispatchEvent(debouncedResizeEvent);
   }, [visibleDimensions]);

   return <VisibleHeight height={visibleDimensions.height} />;
};

export { VisibleScreenDimentions };
